module.exports = __webpack_public_path__ + "static/img/项目管理.a19b9c46.png";